import { RssCrawlResultConstants } from "../constants/RssCrawlResultConstants";
import { RssCrawlResultServices } from "../services/RssCrawlResultServices";

export const RssCrawlResultActions = {
  fetchGetList,
};

function fetchGetList(isForViewLog) {
  return (dispatch) => {
    dispatch(request());
    RssCrawlResultServices.getList(isForViewLog).then(
      (data) => dispatch(success(data)),
      (error) => dispatch(failure(error))
    );
  };

  function request() {
    return {
      type: RssCrawlResultConstants.FETCH_RSS_CRAWL_RESULT_PENDING,
    };
  }

  function success(data) {
    return {
      type: RssCrawlResultConstants.FETCH_RSS_CRAWL_RESULT_GET_LIST_SUCCESS,
      payload: data,
    };
  }

  function failure(error) {
    return {
      type: RssCrawlResultConstants.FETCH_RSS_CRAWL_RESULT_ERROR,
      error: error,
    };
  }
}
